var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCsvOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3704_53968)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4595 0.5L2.57187 0.500038C1.63998 0.500044 0.884536 1.25549 0.884535 2.18738L0.884521 14.2431C0.884521 15.175 1.63997 15.9305 2.57186 15.9305L11.6987 15.9305L11.6987 15.1805L2.57187 15.1805C2.05419 15.1805 1.63452 14.7608 1.63452 14.2431L1.63454 2.18738C1.63454 1.6697 2.0542 1.25004 2.57187 1.25004L7.63048 1.25001V5.87151H12.2514V11.1581H13.0014V5.04786L8.4595 0.5ZM12.015 5.12151L8.38048 1.48223V5.12151H12.015Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35232 10.3625C5.26174 10.3961 5.12006 10.4304 4.9787 10.4304C4.52032 10.4304 4.13538 10.0623 4.13538 9.03816C4.13538 7.99687 4.55979 7.61774 4.97287 7.61774C5.15402 7.61774 5.2446 7.65139 5.33518 7.697L5.44839 7.18201C5.37432 7.1364 5.19931 7.08594 4.95023 7.08594C4.27124 7.08594 3.49585 7.61224 3.49585 9.07762C3.49585 10.2548 3.99369 10.9677 4.86515 10.9677C5.11424 10.9677 5.31221 10.9286 5.42543 10.872L5.35232 10.3625Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02322 10.8096C6.14227 10.8891 6.43081 10.9681 6.71386 10.9681C7.399 10.9681 7.88552 10.5327 7.88552 9.84784C7.88552 9.44057 7.69337 9.07245 7.21235 8.75576C6.82158 8.507 6.6689 8.37114 6.6689 8.07677C6.6689 7.84418 6.83323 7.61257 7.17838 7.61257C7.38218 7.61257 7.54101 7.67468 7.64808 7.74261L7.7558 7.22212C7.65423 7.15969 7.43264 7.08626 7.1897 7.08626C6.47642 7.08626 6.07466 7.55563 6.07466 8.14987C6.07466 8.56296 6.36903 8.94208 6.79344 9.21349C7.10495 9.42893 7.2916 9.60425 7.2916 9.90962C7.2916 10.227 7.08781 10.4421 6.71418 10.4421C6.51589 10.4421 6.26681 10.3741 6.12544 10.2894L6.02322 10.8096Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0575 10.9677H9.73131L10.6241 7.08594H9.95613L9.64494 8.81366C9.56407 9.26298 9.4777 9.75823 9.42594 10.236H9.4088C9.35122 9.76405 9.2532 9.25166 9.17848 8.82531L8.85629 7.08594H8.18247L9.0575 10.9677Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3563 13.1273L13.6917 13.1273L13.3167 13.1273V13.5023V16.0667H11.5146L11.5146 13.5022V13.1272L11.1396 13.1272L10.4618 13.1272L12.3861 10.818L14.3563 13.1273Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3704_53968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.446289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCsvOutline);
export default __webpack_public_path__ + "static/media/upload-csv-outline.2d5855cdb8ed31f8fc4d6a72a977ecba.svg";
export { ForwardRef as ReactComponent };